import React, { useEffect } from 'react'

import usePromo from 'artkive/hooks/usePromo'
import {
  getKlaviyoArtkiveProperties,
  handleKlaviyoFormSubmit,
  isEmailStepSubmitted,
  isPhoneStepSubmitted,
  // TODO For follow-up task after Escalating Email Grabber
  // KLAVIYO_DESKTOP_POPUP_SMS_ONLY_FORM_ID,
  // KLAVIYO_MOBILE_POPUP_SMS_ONLY_FORM_ID,
  // PROMO_SMS_ONLY,
} from 'artkive/utils/klaviyoHelpers'

const withKlaviyoFormCatch = (Component) => {
  const WithKlaviyoFormCatchWrapper = (props) => {
    const { dispatchPromo } = usePromo({})

    useEffect(() => {
      // Check if both steps of the Klaviyo forms (email & phone)
      // were submitted recently (within 7 days), but tab was closed.
      // If yes, apply promoForPhoneNumber
      // If only email step was submitted, apply ARTKIVE promo
      const emailStep = isEmailStepSubmitted()
      const phoneStep = isPhoneStepSubmitted()
      const promoForPhoneNumber = getKlaviyoArtkiveProperties()?.promoForPhoneNumber
      if (emailStep && phoneStep) {
        dispatchPromo({ promoCode: promoForPhoneNumber })
      } else if (emailStep && !phoneStep) {
        dispatchPromo()
      }
    }, [dispatchPromo])

    useEffect(() => {
      const onSubmitEmail = async ({ firstName, email, formId, formType }) => {
        const step = 'email'
        await dispatchPromo({ firstName, email, formId, formType, step })
      }

      const onSubmitPhoneNumber = async ({ phoneNumber, formId, formType }) => {
        const step = 'sms'

        // TODO For follow-up task after Escalating Email Grabber
        // const isSmsOnlyForm =
        //   formId === KLAVIYO_DESKTOP_POPUP_SMS_ONLY_FORM_ID ||
        //   formId === KLAVIYO_MOBILE_POPUP_SMS_ONLY_FORM_ID
        // await promoActions.dispatchPromo({ phoneNumber, promoCode: isSmsOnlyForm ? PROMO_SMS_ONLY : PROMO_PHONE_NUMBER })
        const promoForPhoneNumber = getKlaviyoArtkiveProperties()?.promoForPhoneNumber
        await dispatchPromo({ phoneNumber, promoCode: promoForPhoneNumber, formId, formType, step })
      }

      const callback = handleKlaviyoFormSubmit(onSubmitEmail, onSubmitPhoneNumber)
      document.addEventListener('click', callback)
      return () => document.removeEventListener('click', callback)
    }, [dispatchPromo])

    return <Component {...props} />
  }

  return WithKlaviyoFormCatchWrapper
}

export default withKlaviyoFormCatch
